
import { useNavigate } from 'react-router-dom';

export default function Categories() {
  const navigate = useNavigate();

  const goToGallery = () => {
    navigate('/gallery');
  };

  return (
    <section id="categories-section" className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Sanat Kategorileri</h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Farklı tekniklerle hazırlanmış eserlerimizi keşfedin. Her kategori kendine özgü 
            güzellik ve sanatsal değer taşır.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Oil Paintings */}
          <div className="group relative overflow-hidden rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors">
            <div 
              className="aspect-[4/3] bg-cover bg-center"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/5b51c4bb634973154c0321e0cad85700.jpg')`
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mx-auto mb-4">
                    <i className="ri-brush-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-2">TUYB</h3>
                  <p className="text-gray-200 mb-6 max-w-sm">
                    Zengin renkler ve derin dokularla hayat bulan klasik sanat eserleri
                  </p>
                  <button 
                    onClick={goToGallery}
                    className="bg-white text-black px-6 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Koleksiyonu Gör
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Watercolor Paintings */}
          <div className="group relative overflow-hidden rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors">
            <div 
              className="aspect-[4/3] bg-cover bg-center"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Beautiful%20watercolor%20painting%20collection%2C%20transparent%20watercolor%20artworks%20with%20flowing%20colors%20and%20soft%20textures%2C%20delicate%20watercolor%20paper%20with%20artistic%20paintings%2C%20gallery%20display%20of%20watercolor%20techniques%2C%20soft%20and%20ethereal%20watercolor%20art%20pieces&width=600&height=450&seq=watercat&orientation=landscape')`
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mx-auto mb-4">
                    <i className="ri-drop-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-2">Sulu Boya</h3>
                  <p className="text-gray-200 mb-6 max-w-sm">
                    Şeffaf ve akışkan tekniklerle yaratılan zarif ve hassas eserler
                  </p>
                  <button 
                    onClick={goToGallery}
                    className="bg-white text-black px-6 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Koleksiyonu Gör
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={goToGallery}
            className="bg-white text-black px-8 py-4 text-lg font-semibold hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            Tüm Koleksiyonu Keşfet
          </button>
        </div>
      </div>
    </section>
  );
}
